export default __webpack_public_path__ + "static/motogp-ignition-493f7c1ac35d5c9f04efc79b5ab28d7f.png";